import React from 'react';
import I18n from 'i18n-js';

import { RCButton, RCMenu } from '@reverbdotcom/cadence/components';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import URLHelpers from '../../shared/url_helpers';
import Location from '../../../lib/wrapped_location';

interface IListingStateProps {
  listing: Listing;
  // Render as a standalone button instead of a menu item, styled to match the menu anchor it replaces.
  buttonProps?: Pick<React.ComponentProps<typeof RCButton>, 'variant' | 'size'>;
}

export const COMPONENT_NAME = 'RelistButton';

export default function RelistButton({ listing, buttonProps = undefined }: IListingStateProps) {
  const sellFormEditListingPath = URLHelpers.sellFormEditListingPath(listing.id, {
    section: 'review',
  });

  function handleClick() {
    trackEvent({
      eventName: MParticleEventName.ClickedComponent,
      componentName: COMPONENT_NAME,
      listingId: listing.id,
    });
    Location.assign(sellFormEditListingPath);
  }

  const label = I18n.t('discovery.listingsManagement.sellerListingCard.relist');

  if (buttonProps) {
    return (
      <RCButton variant={buttonProps.variant} size={buttonProps.size} onClick={handleClick}>
        {label}
      </RCButton>
    );
  }

  return (
    <RCMenu.Item onClick={handleClick}>
      {label}
    </RCMenu.Item>
  );
}
